import React, { useEffect } from "react";
import TopBanner from "../components/TopBanner";
import { ContentWrapper } from "./InsuranceGuidance";
import { CTAButton, CTAButtonWrapper } from "../components/HeroSection";
import StepsTimeline from "../components/StepsTimeline";
import { ImportantNote, NoteIcon, NoteText } from "./Advisors";

const FindAdvisors = ({ openModal }) => {
  useEffect(() => {
    document.title = "Connect with a Licensed Insurance Advisor | Wealthies";
  }, []);

  const stepsData = [
    {
      title: "Step 1 – Submit Your Request",
      desc: "Provide a few basic details so we can understand your requirement.",
    },
    {
      title: "Step 2 – Advisor Connection",
      desc: "Our platform will help connect you with a licensed insurance professional who can assist you further.",
    },
    {
      title: "Step 3 – Understand Your Options",
      desc: "The advisor can help explain available insurance options and policy features so you can make an informed decision.",
    },
  ];

  return (
    <>
      <TopBanner content={"Find an Advisor"} />
      <ContentWrapper>
        <div className="text-content">
          {/* Hero Section */}
          <h2>
            Get Guidance from <span>Licensed Insurance</span> Professionals
          </h2>
          <p>
            Understanding insurance can sometimes feel complicated, especially
            when choosing coverage that suits your needs.
          </p>
          <p>
            Wealthies helps individuals connect with licensed insurance
            professionals who can assist in explaining insurance options and
            policy features.
          </p>
          <p>
            If you would like to understand insurance better or explore coverage
            options, you can submit your request and our team will help connect
            you with a licensed insurance advisor.
          </p>
          {/* Why Speak */}
          <h2>
            Why <span>Speak with</span> an Insurance Advisor
          </h2>
          <p>
            Many individuals prefer speaking with an advisor to understand
            insurance in a clearer and more personalised way.
          </p>
          <ul>
            <p>✔ Explaining insurance coverage options</p>
            <p>✔ Understanding policy features and benefits</p>
            <p>✔ Clarifying premium and coverage details</p>
            <p>✔ Answering insurance-related questions</p>
          </ul>
          <p>
            Speaking with a professional can help individuals make more informed
            decisions.
          </p>
          {/* How it works */}
          <h2>How It Works</h2>
          <StepsTimeline steps={stepsData} />
          {/* Trust Section */}
          <h2>
            Why <span>People</span> Use Wealthies
          </h2>
          <ul>
            <p>✔ Simple insurance explanations</p>
            <p>✔ Access to licensed insurance professionals</p>
            <p>✔ Support through Wealthies Shield</p>
            <p>✔ Transparent guidance approach</p>
          </ul>
          {/* Important Note */}

          <ImportantNote>
            <NoteIcon>i</NoteIcon>
            <NoteText>
              After submitting the request, our team may contact you to
              understand your requirement and help connect you with a{" "}
              <span>licensed insurance professional</span>.
            </NoteText>
          </ImportantNote>
          {/* CTA */}
          <h2>
            Need help <span>understanding</span> insurance?
          </h2>
          <p>
            Submit your request and connect with an advisor who can guide you
            further.
          </p>
          <CTAButtonWrapper>
            <CTAButton onClick={openModal}>
              Get Free Insurance Guidance
            </CTAButton>
          </CTAButtonWrapper>
        </div>
      </ContentWrapper>
    </>
  );
};

export default FindAdvisors;
